import React, {Component} from "react";
import {Table, Thead, Tbody, Tr, Th, Td} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PetRemove from "./PetRemove";
import dayjs from "dayjs";
import { petTypeLabel, petGenderLabel } from "helpers/adminLabels";

class PetList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditModalOpen: false,
            isRemoveModalOpen: false,
            removePet: null,
            editPet: null,
            petListData: [],
        };
        this.onEditOpen = this.onEditOpen.bind(this);
        this.onEditSubmit = this.onEditSubmit.bind(this);
        this.onRemoveOpen = this.onRemoveOpen.bind(this);
        this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
    }

    onEditOpen(pet) {
        this.setState((prevState) => ({
            isEditModalOpen: !prevState.isEditModalOpen,
            editPet: pet,
        }));
    }

    // componentDidMount() {
    //     this.props.getPets()
    // }

    // getAllPets = () => {
    //     //  get pets
    //     axios
    //         .get(`${baseURL}/api/v1/pets/all`, {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem("token")}`,
    //             },
    //         })
    //         .then((res) => {
    //             let response = res?.data;
    //             this.setState({petListData: response});
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }

    onRemoveOpen(pet) {
        this.setState((prevState) => ({
            isRemoveModalOpen: !prevState.isRemoveModalOpen,
            removePet: pet,
        }));
    }

    onRemoveSubmit(pet) {
        this.props.onRemoveItem(pet);
    }

    onEditSubmit(pet) {
        this.props.onEditItem(pet);
    }

    getPetsList(petListData) {
        if (petListData) {
            return petListData?.pets.map((pet, i) => {
                return <Tr key={i}>
                    <Th>{pet?.parentID?.name} {pet?.parentID?.surname}</Th>
                    <Th>{pet?.name}</Th>
                    <Th>{petTypeLabel(pet?.type)}</Th>
                    <Th>{pet?.breed}</Th>
                    <Th>{petGenderLabel(pet?.gender)}</Th>
                    <Th>{dayjs().diff(dayjs(pet?.dateOfBirth), 'y')}</Th>
                    <Th>{pet?.parentID?.email}</Th>
                    <Th>{dayjs(pet?.createdAt).format('DD/MM/YYYY')}</Th>
                    <Td>
                        <div className="button-items">
                            <button
                                type="button"
                                className="btn btn-danger waves-effect waves-light"
                                onClick={() => {
                                    this.onRemoveOpen(pet);
                                }}
                            >
                                <i className="bx bx-trash-alt font-size-16 align-middle"></i>
                            </button>
                        </div>
                    </Td>
                </Tr>
            });
        } else {
            return null;
        }
    }

    render() {
        const {isRemoveModalOpen, removePet} =
            this.state;
        return (
            <div className="table-rep-plugin">
                <div className="table-responsive mb-0" data-pattern="priority-columns">
                    <Table
                        id="tech-companies-1"
                        className="table table-striped table-bordered"
                    >
                        <Thead>
                            <Tr>
                                <Th data-priority="1">Стопанин</Th>
                                <Th data-priority="1">Име на любимеца</Th>
                                <Th data-priority="3">Вид</Th>
                                <Th data-priority="3">Порода</Th>
                                <Th data-priority="3">Пол</Th>
                                <Th data-priority="3">Възраст</Th>
                                <Th data-priority="1">Имейл</Th>
                                <Th data-priority="3">Създаден на</Th>
                                <Th data-priority="3">Премахни</Th>
                            </Tr>
                        </Thead>
                        <Tbody>{this.getPetsList(this.props.list)}</Tbody>
                    </Table>
                </div>
                <PetRemove
                    data={removePet}
                    onSubmit={this.onRemoveSubmit}
                    isRemoveModalOpen={isRemoveModalOpen}
                    onCancel={this.onRemoveOpen}
                />
            </div>
        );
    }
}

export default PetList;
